import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDList,
  FDListItem,
  FDListItemSecondary,
  FDListItemText,
  FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { FDWizardModalWrapper } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import AdditionalIncomeListItemLayout from './AdditionalIncomeListItemLayout';
import metaOverrideSet from '../metaOverrideSet';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleAdd = (rel) => () => {
    loadModalCollectionByLink(rel.link('related').url());
  };

  return (
    <FDWizardModalWrapper resource={resource}>
      <FDStack direction={'column'} spacing={1}>
        <MetaControlField attr={'question'} />
        <MetaControlField attr={'description'} />
      </FDStack>
      <FDList variant="separated">
        {resource.attr('incomes').resources().list().map((incomeItemRes) => {
          return (
            <MetaResourceRenderer
              key={incomeItemRes.id()}
              layout={AdditionalIncomeListItemLayout}
              resource={incomeItemRes}
              metaOverrideSet={metaOverrideSet}
            />
          );
        })}
        {resource.withRelationship(fr.relationships.subStep.name, (rel) => (
          <FDListItem onClick={handleAdd(rel)}>
            <FDListItemText primaryText={resource.attr('buttonText')} />
            <FDListItemSecondary>
              <FDSecondaryActionIconButton icon="add" />
            </FDListItemSecondary>
          </FDListItem>
        ),
        () => null)}
      </FDList>
    </FDWizardModalWrapper>
  );
};

export default Layout;
